import { Colors, Metrics, Typography } from "../../resources";
import { StyleSheet, Text, TouchableOpacity, ViewStyle } from "react-native";

import React from "react";

interface IProps {
  onPress: () => void;
  color?: string;
  style?: ViewStyle | null;
  outlined?: boolean;
  disabled?: boolean;
  alignment?: boolean;
  backgroundColor?: string;
  textColor?: string;
  children: string;
}

const SButton: React.FC<IProps> = ({
  onPress,
  color = Colors.blue700,
  textColor = Colors.white,
  style = {},
  outlined = false,
  disabled = false,
  alignment = false,
  backgroundColor = Colors.blue400,
  children,
}) => {
  return (
    <TouchableOpacity
      onPress={onPress}
      style={[
        styles.buttonStyle,
        {
          backgroundColor,
          borderColor: backgroundColor,
        },
        {
          opacity: disabled
            ? Metrics.buttonLowOpacity
            : Metrics.buttonHighOpacity,
        },
        outlined ? [styles.outlined, { borderColor: backgroundColor }] : null,
        alignment ? styles.buttonInline : {},
        style,
      ]}
    >
      <Text
        style={[
          styles.textStyle,
          { color: textColor },
          outlined
            ? {
                color,
              }
            : {},
        ]}
      >
        {children}
      </Text>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  buttonStyle: {
    flexGrow: 0,
    flexShrink: 0,
    justifyContent: "center",
    height: 44,
    borderRadius: Metrics.borderRadiusStandard,
    borderWidth: 1,
  },
  textStyle: {
    ...Typography.bodyNumber,
    flexDirection: "row",
    paddingLeft: 12,
    paddingRight: 12,
    color: Colors.white,
    textAlign: "center",
  },
  outlined: {
    backgroundColor: "transparent",
  },
  buttonInline: {
    marginLeft: 24,
  },
});

export default SButton;
